import React from 'react';
import Button from './ui/Button';
import { IconTrash } from './ui/Icons';
import { isGpAktiv } from './TransaktionAnlegen.utils';

const SicherheitenForm = ({ grundpfandrechte, addGrundpfandrecht, removeGrundpfandrecht, handleGrundpfandrechtChange, addPfandobjekt, removePfandobjekt, handlePfandobjektChange, errors, renderFieldErrors }) => {
  return (
    <div className="form-section">
      <div className="section-header">
        <h3 className="section-title">Grundpfandrechte</h3>
        <Button variant="outline-primary" size="xs" icon ariaLabel="Grundpfandrecht hinzufügen" onClick={addGrundpfandrecht} tooltip="Grundpfandrecht hinzufügen">+</Button>
      </div>

      {grundpfandrechte.map((grundpfandrecht, index) => {
        const aktiv = isGpAktiv(grundpfandrecht);
        const reqStar = aktiv ? <span className="required-star">*</span> : null;

        return (
          <div key={grundpfandrecht.id} className="grundpfandrecht-item">
            {index > 0 && <hr className="section-divider" />}
            {grundpfandrechte.length > 1 && (
              <div className="block-header">
                <span className="grundpfandrecht-title">{index + 1}. Grundpfandrecht</span>
                <Button variant="danger" size="xs" icon ariaLabel="Grundpfandrecht löschen" onClick={() => removeGrundpfandrecht(grundpfandrecht.id)} tooltip="Grundpfandrecht löschen">
                  <IconTrash width="12" height="18" />
                </Button>
              </div>
            )}

            <div className="form-row">
              <div className="form-field full-width">
                <label htmlFor={`grundpfandrecht-aktenzeichen-${grundpfandrecht.id}`}>Aktenzeichen {reqStar}</label>
                <input
                  id={`grundpfandrecht-aktenzeichen-${grundpfandrecht.id}`}
                  type="text"
                  value={grundpfandrecht.aktenzeichen}
                  onChange={(e) => handleGrundpfandrechtChange(grundpfandrecht.id, 'aktenzeichen', e.target.value)}
                  className={errors[`gp_${grundpfandrecht.id}_aktenzeichen`] ? 'error' : ''}
                  placeholder=""
                  title="z.B. GP-2024-001"
                  maxLength={100}
                />
                {renderFieldErrors(`gp_${grundpfandrecht.id}_aktenzeichen`)}
              </div>
            </div>

            <div className="form-row two-equal">
              <div className="form-field">
                <label htmlFor={`grundpfandrecht-betrag-${grundpfandrecht.id}`}>Betrag {reqStar}</label>
                <textarea
                  id={`grundpfandrecht-betrag-${grundpfandrecht.id}`}
                  className={`compact-textarea ${errors[`gp_${grundpfandrecht.id}_betrag`] ? 'error' : ''}`}
                  rows="2"
                  value={grundpfandrecht.betrag}
                  onChange={(e) => handleGrundpfandrechtChange(grundpfandrecht.id, 'betrag', e.target.value)}
                  title="z.B. 1.800.000,00 zzgl. Zinsen und Nebenleistungen"
                  maxLength={100}
                />
                {renderFieldErrors(`gp_${grundpfandrecht.id}_betrag`)}
              </div>
              <div className="form-field">
                <label htmlFor={`grundpfandrecht-umfang-${grundpfandrecht.id}`}>Umfang {reqStar}</label>
                <textarea
                  id={`grundpfandrecht-umfang-${grundpfandrecht.id}`}
                  className={`compact-textarea ${errors[`gp_${grundpfandrecht.id}_umfang`] ? 'error' : ''}`}
                  rows="2"
                  value={grundpfandrecht.umfang}
                  onChange={(e) => handleGrundpfandrechtChange(grundpfandrecht.id, 'umfang', e.target.value)}
                  title="z.B. 300.000,00 im Vorrang zu 110.000,00 und im Gleichrang mit dem Rest"
                  maxLength={100}
                />
                {renderFieldErrors(`gp_${grundpfandrecht.id}_umfang`)}
              </div>
            </div>

            <div className="form-row long-short">
              <div className="form-field">
                <label htmlFor={`grundpfandrecht-rechtlichergrund-${grundpfandrecht.id}`}>Rechtlicher Grund {reqStar}</label>
                <input
                  id={`grundpfandrecht-rechtlichergrund-${grundpfandrecht.id}`}
                  type="text"
                  value={grundpfandrecht.rechtlicherGrund}
                  onChange={(e) => handleGrundpfandrechtChange(grundpfandrecht.id, 'rechtlicherGrund', e.target.value)}
                  placeholder="z.B. Kreditvertrag nebst etwaiger Sicherheitenabreden"
                  title="z.B. Kreditvertrag nebst etwaiger Sicherheitenabreden"
                  className={errors[`gp_${grundpfandrecht.id}_rechtlicherGrund`] ? 'error' : ''}
                  maxLength={100}
                />
                {renderFieldErrors(`gp_${grundpfandrecht.id}_rechtlicherGrund`)}
              </div>
              <div className="form-field">
                <label htmlFor={`grundpfandrecht-datum-${grundpfandrecht.id}`}>Datum rechtl. Grund {reqStar}</label>
                <input
                  id={`grundpfandrecht-datum-${grundpfandrecht.id}`}
                  type="date"
                  value={grundpfandrecht.datumRechtlicherGrund}
                  onChange={(e) => handleGrundpfandrechtChange(grundpfandrecht.id, 'datumRechtlicherGrund', e.target.value)}
                  className={errors[`gp_${grundpfandrecht.id}_datumRechtlicherGrund`] ? 'error' : ''}
                />
                {renderFieldErrors(`gp_${grundpfandrecht.id}_datumRechtlicherGrund`)}
              </div>
            </div>

            <div className="subsection-header">
              <h4 className="subsection-title">Pfandobjekte</h4>
              <Button variant="outline-primary" size="xs" icon ariaLabel="Pfandobjekt hinzufügen" onClick={() => addPfandobjekt(grundpfandrecht.id)} tooltip="Pfandobjekt hinzufügen">+</Button>
            </div>

            {grundpfandrecht.pfandobjekte.map((pfandobjekt, pfandobjektIndex) => (
              <div key={pfandobjekt.id} className="pfandobjekt-block">
                {grundpfandrecht.pfandobjekte.length > 1 && (
                  <div className="pfandobjekt-block-header">
                    <span className="pfandobjekt-title">{pfandobjektIndex + 1}. Immobilie</span>
                    <Button variant="danger" size="xs" icon ariaLabel="Pfandobjekt löschen" onClick={() => removePfandobjekt(grundpfandrecht.id, pfandobjekt.id)} tooltip="Pfandobjekt löschen">
                      <IconTrash width="12" height="18" />
                    </Button>
                  </div>
                )}

                <div className="form-row identifikationstyp-row">
                  <div className="form-field full-width">
                    <div className="radio-group">
                      <label className="radio-label">
                        <input
                          type="radio"
                          name={`pfandobjekt-identifikationstyp-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          value="VerweisAufGrundbuchblatt"
                          checked={(pfandobjekt.identifikationstyp || 'VerweisAufGrundbuchblatt') === 'VerweisAufGrundbuchblatt'}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikationstyp', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikationstyp`] ? 'error' : ''}
                        />
                        <span>Verweis auf Grundbuchblatt</span>
                      </label>
                      <label className="radio-label">
                        <input
                          type="radio"
                          name={`pfandobjekt-identifikationstyp-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          value="BezeichnungImBestandsverzeichnis"
                          checked={(pfandobjekt.identifikationstyp || 'VerweisAufGrundbuchblatt') === 'BezeichnungImBestandsverzeichnis'}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikationstyp', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikationstyp`] ? 'error' : ''}
                        />
                        <span>Bezeichnung im Bestandsverzeichnis</span>
                      </label>
                    </div>
                    {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikationstyp`)}
                  </div>
                </div>

                {/* Gemeinsame Felder für beide Identifikationstypen */}
                <div className="form-row two-equal">
                  <div className="form-field">
                    <label htmlFor={`pfandobjekt-abteilung-${grundpfandrecht.id}-${pfandobjekt.id}`}>Abt. des Grundbuchs {reqStar}</label>
                    <input
                      id={`pfandobjekt-abteilung-${grundpfandrecht.id}-${pfandobjekt.id}`}
                      type="text"
                      value={pfandobjekt.abteilungGrundbuch || ''}
                      onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'abteilungGrundbuch', e.target.value)}
                      placeholder=""
                      title="z.B. III"
                      className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_abteilungGrundbuch`] ? 'error' : ''}
                      maxLength={10}
                    />
                    {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_abteilungGrundbuch`)}
                  </div>
                  <div className="form-field">
                    <label htmlFor={`pfandobjekt-laufendenr-${grundpfandrecht.id}-${pfandobjekt.id}`}>Lfd. Nummer {reqStar}</label>
                    <input
                      id={`pfandobjekt-laufendenr-${grundpfandrecht.id}-${pfandobjekt.id}`}
                      type="text"
                      value={pfandobjekt.lfdNrAbteilungGrundbuch || ''}
                      onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'lfdNrAbteilungGrundbuch', e.target.value)}
                      className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_lfdNrAbteilungGrundbuch`] ? 'error' : ''}
                      placeholder=""
                      title="z.B. 23"
                    />
                    {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_lfdNrAbteilungGrundbuch`)}
                  </div>
                </div>

                {/* Felder für VerweisAufGrundbuchblatt */}
                {(pfandobjekt.identifikationstyp || 'VerweisAufGrundbuchblatt') === 'VerweisAufGrundbuchblatt' && (
                  <>
                    <div className="form-row two-equal">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-ortGrundbuch-${grundpfandrecht.id}-${pfandobjekt.id}`}>Ort Grundbuch {reqStar}</label>
                        <input
                          id={`pfandobjekt-ortGrundbuch-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.ortGrundbuch || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.ortGrundbuch', e.target.value)}
                          placeholder=""
                          title="Grünheide"
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.ortGrundbuch`] ? 'error' : ''}
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.ortGrundbuch`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-amtsgericht-${grundpfandrecht.id}-${pfandobjekt.id}`}>Amtsgericht {reqStar}</label>
                        <input
                          id={`pfandobjekt-amtsgericht-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.amtsgericht || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.amtsgericht', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.amtsgericht`] ? 'error' : ''}
                          placeholder=""
                          title="Fürstenwalde/Spree"
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.amtsgericht`)}
                      </div>
                    </div>

                    <div className="form-row two-equal">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-band-${grundpfandrecht.id}-${pfandobjekt.id}`}>Band</label>
                        <input
                          id={`pfandobjekt-band-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.band || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.band', e.target.value)}
                          placeholder=""
                          title="z.B. 54"
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.band`] ? 'error' : ''}
                          maxLength={10}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.band`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-blattNr-${grundpfandrecht.id}-${pfandobjekt.id}`}>Blatt {reqStar}</label>
                        <input
                          id={`pfandobjekt-blattNr-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.blattNr || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.blattNr', e.target.value)}
                          placeholder=""
                          title="9440"
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.blattNr`] ? 'error' : ''}
                          maxLength={10}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.blattNr`)}
                      </div>
                    </div>

                    <div className="form-row long-short">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-strasse-${grundpfandrecht.id}-${pfandobjekt.id}`}>Straße {reqStar}</label>
                        <input
                          id={`pfandobjekt-strasse-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.strasse || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.strasse', e.target.value)}
                          placeholder=""
                          title="Karl-Marx-Str."
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.strasse`] ? 'error' : ''}
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.strasse`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-hausNr-${grundpfandrecht.id}-${pfandobjekt.id}`}>Hausnr. {reqStar}</label>
                        <input
                          id={`pfandobjekt-hausNr-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.hausNr || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.hausNr', e.target.value)}
                          placeholder=""
                          title="17a"
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.hausNr`] ? 'error' : ''}
                          maxLength={10}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.hausNr`)}
                      </div>
                    </div>

                    <div className="form-row short-long">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-plz-${grundpfandrecht.id}-${pfandobjekt.id}`}>Postleitzahl {reqStar}</label>
                        <input
                          id={`pfandobjekt-plz-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.plz || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.plz', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.plz`] ? 'error' : ''}
                          maxLength="5"
                          placeholder=""
                          title="z.B. 33100"
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.plz`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-ort-${grundpfandrecht.id}-${pfandobjekt.id}`}>Ort {reqStar}</label>
                        <input
                          id={`pfandobjekt-ort-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.ort || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.ort', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.ort`] ? 'error' : ''}
                          placeholder=""
                          title="Paderborn"
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.ort`)}
                      </div>
                    </div>
                  </>
                )}

                {/* Felder für BezeichnungImBestandsverzeichnis */}
                {(pfandobjekt.identifikationstyp || 'VerweisAufGrundbuchblatt') === 'BezeichnungImBestandsverzeichnis' && (
                  <>
                    <div className="form-row two-equal">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-lfdnrbv-${grundpfandrecht.id}-${pfandobjekt.id}`}>Lfd. Nr. im Bestandsverzeichnis {reqStar}</label>
                        <input
                          id={`pfandobjekt-lfdnrbv-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.lfdNrImBestandsverzeichnis || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.lfdNrImBestandsverzeichnis', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.lfdNrImBestandsverzeichnis`] ? 'error' : ''}
                          placeholder=""
                          title="z.B. 1"
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.lfdNrImBestandsverzeichnis`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-gemarkung-${grundpfandrecht.id}-${pfandobjekt.id}`}>Gemarkung {reqStar}</label>
                        <input
                          id={`pfandobjekt-gemarkung-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.gemarkung || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.gemarkung', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.gemarkung`] ? 'error' : ''}
                          placeholder=""
                          title="z.B. Musterstadt"
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.gemarkung`)}
                      </div>
                    </div>

                    <div className="form-row two-equal">
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-flur-${grundpfandrecht.id}-${pfandobjekt.id}`}>Flur {reqStar}</label>
                        <input
                          id={`pfandobjekt-flur-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.flur || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.flur', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.flur`] ? 'error' : ''}
                          placeholder=""
                          title="z.B. 2"
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.flur`)}
                      </div>
                      <div className="form-field">
                        <label htmlFor={`pfandobjekt-flurstueck-${grundpfandrecht.id}-${pfandobjekt.id}`}>Flurstück {reqStar}</label>
                        <input
                          id={`pfandobjekt-flurstueck-${grundpfandrecht.id}-${pfandobjekt.id}`}
                          type="text"
                          value={pfandobjekt.identifikation?.flurstueck || ''}
                          onChange={(e) => handlePfandobjektChange(grundpfandrecht.id, pfandobjekt.id, 'identifikation.flurstueck', e.target.value)}
                          className={errors[`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.flurstueck`] ? 'error' : ''}
                          placeholder=""
                          title="z.B. 123/45"
                          maxLength={100}
                        />
                        {renderFieldErrors(`po_${grundpfandrecht.id}_${pfandobjekt.id}_identifikation.flurstueck`)}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SicherheitenForm;
